import type {
    RunConnectivityDetectionType,
    ConnectivityDetectionWorkerInputs,
    AnyPcbBakedNode,
    INetHashMap,
    NodeUid,
    PcbNodesMap,
    GraphNodeAttributes,
    calculateAirwires,
} from "@buildwithflux/core";
import * as Comlink from "comlink";
import type {IVector2} from "@buildwithflux/models";

interface ConnectivityGraphWorkerApi {
    runConnectivityDetectionInWorker(
        inputs: ConnectivityDetectionWorkerInputs,
    ): Promise<{foundEdges: Set<string>; graphNodes: GraphNodeAttributes[]}>;
    runCalculateAirwiresInWorker(
        netMap: INetHashMap,
        connectedComponents: readonly NodeUid[][],
        pcbLayoutNodes: PcbNodesMap<AnyPcbBakedNode>,
        nodePositionsWorld?: {[key: string]: IVector2 | null},
        nodeAttributesMap?: {[key: string]: Readonly<GraphNodeAttributes> | null},
    ): Promise<ReturnType<typeof calculateAirwires>>;
}

const worker = new Worker(new URL("./connGraphWorker.ts", import.meta.url), {type: "module"});
const comlink = Comlink.wrap<ConnectivityGraphWorkerApi>(worker);

export const workerRunConnectivityDetection = comlink.runConnectivityDetectionInWorker as RunConnectivityDetectionType;
export const workerRunComputeAirwires = comlink.runCalculateAirwiresInWorker;
